import { Component, Injector, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ProjectService } from '@app/main/resourcesAllocation/projects/project.service';
import {  AllocationSheetsServiceProxy, GetStaffAndUserListViewDto, GetWeeklyPayrollReportFilter, PersonnelsServiceProxy, PagedResultDtoOfWeeklyPayrollReportDto, ResourceAllocationDateWiseListDto, ResourceAllocationDetailDto, ResourceAllocationDto, StaffRoleType, StaffsAndUsersServiceProxy } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';
import { forkJoin, ReplaySubject, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { WidgetComponentBaseComponent } from '../widget-component-base';
import { takeUntil } from '@node_modules/rxjs/operators';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { CustomDateAdapter } from '@shared/helpers/CustomDateAdapter';

@Component({
  selector: 'app-widget-weekly-payroll-report',
  templateUrl: './widget-weekly-payroll-report.component.html',
  styleUrls: ['./widget-weekly-payroll-report.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: DateAdapter, useClass: CustomDateAdapter }
  ],
})

  export class WidgetWeeklyPayrollReportComponent extends WidgetComponentBaseComponent
  implements OnInit, OnDestroy {
    selectedDateRange: moment.Moment[] = [
      this.getWeekStartDate(new Date().setDate(new Date().getDate())),
      this.getWeekEndDate(new Date().setDate(new Date().getDate()))
    ];
  filterText: any;
  endDate: moment.Moment;
  startDate: moment.Moment;
  projectId:any;
  resourceAllocationList: PagedResultDtoOfWeeklyPayrollReportDto;
  getWeeklyPayrollReportFilter : GetWeeklyPayrollReportFilter = new GetWeeklyPayrollReportFilter();
  maxcount:number=0;
  allocations:any[] = [];
  names: any[];
  private _personnels: any[];
  public get personnels(): any[] {
    return this._personnels;
  }
  public set personnels(value: any[]) {
    this._personnels = value;
  }
  company: any[];
  delegationSupervisor: GetStaffAndUserListViewDto;
  supervisorList: GetStaffAndUserListViewDto[] = [];
  nameFilterIsActive: boolean;
  personnelFilterIsActive: boolean;
  companyFilterIsActive: boolean;
  filterNameShow: String;
  filterNameIsSingle: boolean;
  public nameFormCtrl: FormControl = new FormControl();
  public nameFilterFormCtrl: FormControl = new FormControl();
  public filteredName: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public personnelFormCtrl: FormControl = new FormControl();
  public personnelFilterFormCtrl: FormControl = new FormControl();
  public filteredPersonnel: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public companyFormCtrl: FormControl = new FormControl();
  public companyFilterFormCtrl: FormControl = new FormControl();
  public filteredCompany: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  protected _onDestroy = new Subject<void>();
  resourceAllocationDto: ResourceAllocationDto;
  constructor(injector: Injector,
    private _allocationSheetsServiceProxy: AllocationSheetsServiceProxy,
    private _sessionService: AppSessionService,
    private _projectService:ProjectService,
    private _personnelsServiceProxy : PersonnelsServiceProxy,
    private _fileDownloadService: FileDownloadService) {
    super(injector);
  }


  async ngOnInit() {
    this.projectId = await this._projectService.getCurrentOrDefaultProjectId();
    this.startDate =this.selectedDateRange[0];
    this.endDate = this.selectedDateRange[1];
    this.runDelayed(()=>this.GetWeeklyPayrollReportList());

    const editData = forkJoin({
      names: this._allocationSheetsServiceProxy
      .getStaffByStaticRole(this._sessionService.defaultSupervisorRoleId),
      personnels: this._personnelsServiceProxy.getAllPersonnelNameValue(),
      company: this._personnelsServiceProxy.getAllPersonnelCompanyNameValue()
  });

  editData.subscribe((data) => {
      this.filteredName.next(data.names.slice());
      this.filteredPersonnel.next(data.personnels.personnel.slice());
      this.filteredCompany.next(data.company.slice());
      this.names = data.names;
      this.personnels = data.personnels.personnel;
      this.company = data.company;
  });
  this.initiateFiltersValueChanges();
  }

   GetPrevWeek(){
    var current_start_date = this.startDate.toDate();
    this.onDateRangeFilterChange([
      this.getWeekStartDate(((new Date(current_start_date))).setDate((current_start_date).getDate() - 1)),
      this.getWeekEndDate((new Date(current_start_date)).setDate((current_start_date).getDate() - 1)),
     ]);
  }

   GetNextWeek(){
    var current_end_date = this.endDate.toDate();
    this.onDateRangeFilterChange([
      this.getWeekStartDate(((new Date(current_end_date))).setDate((current_end_date).getDate() + 1)),
      this.getWeekEndDate((new Date(current_end_date)).setDate((current_end_date).getDate() + 1)),
     ]);
  }

  private initiateFiltersValueChanges() {
    this.nameFilterFormCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
            this.filterNames();
        });

    this.personnelFilterFormCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
            this.filterPersonnels();
        });

    this.companyFilterFormCtrl.valueChanges
        .pipe(takeUntil(this._onDestroy))
        .subscribe(() => {
            this.filterCompany();
        });
}
 filterNames() {
  if (!this.names) {
      return;
  }
  let search = this.nameFilterFormCtrl.value;
  if (!search) {
      this.filteredName.next(this.names.slice());
      return;
  } else {
      search = search.toLowerCase();
  }

  this.filteredName.next(
      this.names?.filter(
          (param) => param.staffUser.firstName.toLowerCase().indexOf(search) > -1
      )
  );
}
 filterPersonnels() {
  if (!this.personnels) {
      return;
  }

  let search = this.personnelFilterFormCtrl.value;
  if (!search) {
      this.filteredPersonnel.next(this.personnels.slice());
      return;
  } else {
      search = search.toLowerCase();
  }

  this.filteredPersonnel.next(
      this.personnels?.filter(
        (mgr) => `${mgr.firstName} ${mgr.lastName}`.toLowerCase().indexOf(search) > -1
      )
  );
}
 filterCompany() {
  if (!this.company) {
      return;
  }

  let search = this.companyFilterFormCtrl.value;
  if (!search) {
      this.filteredCompany.next(this.company.slice());
      return;
  } else {
      search = search.toLowerCase();
  }

  this.filteredCompany.next(
      this.company?.filter(
          (company) => company.companyName.toLowerCase().indexOf(search) > -1
      )
  );
}

  subDateRangeFilter() {
    abp.event.on(
      'app.dashboardFilters.dateRangePicker.onDateChange',
      this.onDateRangeFilterChange
    );
  }

  onDateRangeFilterChange = (dateRange) => {
    if (
      !dateRange ||
      dateRange.length !== 2 ||
      (this.selectedDateRange[0] === dateRange[0] &&
        this.selectedDateRange[1] === dateRange[1])
    ) {
      return;
    }
    this.startDate=dateRange[0];
    this.endDate =dateRange[1]
    this.GetWeeklyPayrollReportList();
  };

  GetWeeklyPayrollReportList = (nameFilter:number[]=null,personnelFilter:string[]=null,companyFilter:string[]=null) => {
    this.primengTableHelper.showLoadingIndicator();

    this._allocationSheetsServiceProxy.getWeeklyPayrollReport(this.startDate,nameFilter,personnelFilter,companyFilter,null,0,7).pipe(finalize(() => this.primengTableHelper.hideLoadingIndicator()))
      .subscribe((result) => {
        this.resourceAllocationList = result;
        this.primengTableHelper.totalRecordsCount = result.items.length;
        this.primengTableHelper.records = result.items;
        this.primengTableHelper.hideLoadingIndicator();
        this.ConvertObjectToarray(result);
      });
  }

  ExportData = (type:string) => {

    let personnelFilter =[];
    let nameFilter =[];
    let companyFilter=[];

  const params = {
          filterText: this.filterText,
          name: this.nameFormCtrl.value || null,
          personnel: this.personnelFormCtrl.value || null,
          company: this.companyFormCtrl.value || null,
      };
      if(params.personnel!=null)
      {
        params.personnel.forEach((element: { id: any  }) => {
            personnelFilter.push(element.id);
        });
      }
      if(params.name!=null)
      {
        params.name.forEach((element: { staffUser: { staffId: any; }; }) => {
          nameFilter.push(element.staffUser.staffId);
        });
      }

      if(params.company!=null)
      {
        params.company.forEach((element: { companyValue: any; }) => {
          companyFilter.push(element.companyValue);
        });
      }

    this.getWeeklyPayrollReportFilter.date = this.startDate;
    this.getWeeklyPayrollReportFilter.supervisor = nameFilter;
    this.getWeeklyPayrollReportFilter.personnel = personnelFilter;
    this.getWeeklyPayrollReportFilter.company = companyFilter;
    this.getWeeklyPayrollReportFilter.sorting = null;
    this.getWeeklyPayrollReportFilter.skipCount = 0;
    this.getWeeklyPayrollReportFilter.maxResultCount = 7;

    if(type==='xlsx')
    {
    this._allocationSheetsServiceProxy.exportWeeklyPayrollReportToExcel(this.getWeeklyPayrollReportFilter)
      .subscribe((result) => {
         this._fileDownloadService.downloadTempFile(result);
      });
    }
    if(type==='csv'){
      this._allocationSheetsServiceProxy.exportWeeklyPayrollReportToCSV(this.getWeeklyPayrollReportFilter)
      .subscribe((result) => {
         this._fileDownloadService.downloadTempFile(result);
      });
    }
  }

  ConvertObjectToarray(resourceAllocationListDto:PagedResultDtoOfWeeklyPayrollReportDto)
  {
    this.allocations=[];
    for (let i = 0; i < resourceAllocationListDto.items.length; i++)
    {
      this.allocations.push(resourceAllocationListDto.items[i]);
    }
  }
  refresh() {
    this.filtersChange();
  }

clear() {
    this.filterText = null;
    this.nameFormCtrl.reset();
    this.personnelFormCtrl.reset();
    this.companyFormCtrl.reset();
    this.filtersChange();
    this.personnelFilterIsActive = false
    this.nameFilterIsActive = false
    this.companyFilterIsActive = false
}

 getWeekEndDate(date): moment.Moment {
  const inputDate = new Date(date);
  const nextWeekStartDate = new Date(inputDate.setDate(inputDate.getDate() - inputDate.getDay()+ (inputDate.getDay() == 0 ? -6:1) ));
  const nextWeekEndDate = new Date(inputDate.setDate(inputDate.getDate() - inputDate.getDay() + 7 ));
  this.startDate = this.formatDate(nextWeekStartDate);
  this.endDate = this.formatDate(nextWeekEndDate);
  return this.formatDate(nextWeekEndDate);
}

formatDate(date):moment.Moment {
  const currentDate = moment(date);
  currentDate.format('DD/MM/YY');
  return currentDate;
}

getWeekStartDate(date) {
  const inputDate = new Date(date);
  const nextWeekStartDate = new Date(inputDate.setDate(inputDate.getDate() - inputDate.getDay()+ (inputDate.getDay() == 0 ? -6:1) ));
  this.startDate = this.formatDate(nextWeekStartDate);
  return this.formatDate(nextWeekStartDate);
}

onDateSelected(event) {
  var dateString = event.targetElement.value;
  var dateParts = dateString.split("/");
  var jsDate = new Date(dateParts[2], dateParts[1] - 1, dateParts[0]);
  this.onDateRangeFilterChange([
    this.getWeekStartDate(new Date(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate(), 11, 11, 11)),
    this.getWeekEndDate(new Date(jsDate.getFullYear(), jsDate.getMonth(), jsDate.getDate(), 11, 11, 11)),
   ]);
}

GetThisWeek(){
  this.onDateRangeFilterChange([
    this.getWeekStartDate(((new Date())).setDate((new Date()).getDate())),
    this.getWeekEndDate((new Date()).setDate((new Date()).getDate())),
   ]);
}

exportData(type:string)
{
  this.ExportData(type);
}

filtersChange() {
  let personnelFilter =[];
  let nameFilter =[];
  let companyFilter=[];

const params = {
        filterText: this.filterText,
        name: this.nameFormCtrl.value || null,
        personnel: this.personnelFormCtrl.value || null,
        company: this.companyFormCtrl.value || null,
    };
    if(params.personnel!=null)
    {
      params.personnel.forEach((element: { id: any  }) => {
        personnelFilter.push(element.id);
      });
      if(params.personnel.length > 0) {
        this.personnelFilterIsActive = true
      } else {
        this.personnelFilterIsActive = false
      }
    }
    if(params.name!=null)
    {
      params.name.forEach((element: { staffUser: { staffId: any; }; }) => {
        nameFilter.push(element.staffUser.staffId);
      });
      if(params.name.length > 0) {
        this.nameFilterIsActive = true
      } else {
        this.nameFilterIsActive = false
      }
    }

    if(params.company!=null)
    {
      params.company.forEach((element: { companyValue: any; }) => {
        companyFilter.push(element.companyValue);
      });
      if(params.company.length > 0) {
        this.companyFilterIsActive = true
      } else {
        this.companyFilterIsActive = false
      }
    }

    if(params.personnel != null && params.personnel.length == 1 && !this.filterNameIsSingle) {
        this.filterNameShow = params.personnel[0].firstName+' '+params.personnel[0].lastName;
        this.filterNameIsSingle = true;
    } else if(params.name != null && params.name.length == 1 && !this.filterNameIsSingle) {
        this.filterNameShow = params.name[0].staffUser.userName;
        this.filterNameIsSingle = true;
    } else if(params.company != null && params.company.length == 1 && !this.filterNameIsSingle) {
        this.filterNameShow = params.company[0].companyName;
        this.filterNameIsSingle = true;
    } else if(params.personnel != null && params.personnel.length > 1){
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.name != null && params.name.length > 1){
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.company != null && params.company.length > 1){
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.personnel != null && params.personnel.length > 0 && params.name != null && params.name.length > 0) {
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.personnel != null && params.personnel.length > 0 && params.company != null && params.company.length > 0) {
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else if(params.company != null && params.company.length > 0 && params.name != null && params.name.length > 0) {
        this.filterNameShow = "Multiple filters applied"
        this.filterNameIsSingle = false;
    } else {
        this.filterNameShow = ""
        this.filterNameIsSingle = false;
    }

    this.GetWeeklyPayrollReportList(nameFilter,personnelFilter,companyFilter);
}

}
